module.exports = __webpack_public_path__ + "static/media/beamBanner.09b4524f.png";